import React, { useState } from 'react';

const Solutions = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
 const [showVideo, setShowVideo] = useState(false);
  return (
    <div className="relative bg-white">
      {/* Video Modal */}
  

      {/* Content */}
      <div className="relative z-10 px-4 md:px-20 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 mb-2">
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#FDBD26] md:mb-3">
            Experience Farmnet App
          </h1>
          <h1 className="text-[12px] md:text-[40px] font-bold ">
            Service providers
          </h1>
        </div>

        {/* Records Section */}
        <div className="bg-[#2E453D] rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[300px] md:-mt-5 md:h-[700px] flex justify-center items-center cursor-pointer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745110369/image_38_rqoid5.png"
              alt="Mobile"
              className="object-cover w-[20%] h-[50%] md:w-[22%] md:h-[83%] object-center"
            />
            <div
              onClick={() => setIsModalOpen(true)}
              className="absolute inset-0 flex justify-center items-center"
            >
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                alt="Play Icon"
                className="w-[50px] h-[50px] md:w-[110px] md:h-[110px] object-contain hover:scale-105 transition duration-200"
              />
            </div>
          </div>

          <div className="absolute bottom-[10px] md:bottom-8 left-4 md:left-10 text-[#FDBD26]">
            <p className="text-[12px] md:text-[43px] font-bold text-[#FDBD26]">
              Service providers
            </p>
          </div>

          {/* Logo */}
          <div className="absolute left-4 md:left-6 top-0 md:top-4 w-[60px] md:w-[200px] h-[50px] md:h-[80px] z-10">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744195055/image_14_o9yorx.png"
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        <p className='md:text-[32px] md:mt-12 mt-2'>
          The Farmnet Mobile App is designed to empower farmers by providing seamless access to a range of services offered by various service providers. By integrating multiple functionalities into a single platform, the app enhances farm management and productivity.
        </p>

        {/* Farmnet Mobile App Details */}
        <div className="md:mt-12 mt-8">
          <h2 className="text-black font-bold md:text-[32px] text-[8px] mb-12">Accessing Services Through the Farmnet App</h2>
          <div className="space-y-4">
            <p className="text-black text-[40px]"><strong>Service Provider Integration:</strong> The app connects farmers directly with agricultural service providers, including input suppliers, machinery services, and advisory experts...</p>
            <p className="text-black text-[40px]"><strong>Real-Time Data and Advisory:</strong> Farmers receive personalized weather forecasts, market price updates, and agronomy advice tailored to their specific locations and crops...</p>
            <p className="text-black text-[40px]"><strong>Financial Services:</strong> The app facilitates access to financial products...</p>
          </div>

          <h2 className="text-black font-bold md:text-[32px] text-[8px] md:mt-12 mt-5 mb-5 md:mb-12">Benefits of Using the Farmnet Mobile App</h2>
          <div className="space-y-4">
            <p className="text-black text-[40px]"><strong>1. Enhanced Efficiency:</strong> Consolidates various services...</p>
            <p className="text-black text-[40px]"><strong>2. Informed Decision-Making:</strong> Access to real-time data...</p>
            <p className="text-black text-[40px]"><strong>3. Financial Accessibility:</strong> Simplifies loan and investment processes...</p>
            <p className="text-black text-[40px]"><strong>4. Community Engagement:</strong> Forums and channels for farmer interaction...</p>
          </div>

          <div className="space-y-4">
            <p className="text-black text-[40px]">Farmnet Mobile App serves as a comprehensive tool that <strong>integrates essential services</strong> for farmers...</p>
          </div>
        </div>

        <div className="md:h-5 h-2"></div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center">
          <div className="relative w-full h-full">
            <button
       onClick={() => setIsModalOpen(false)}

              className="absolute top-2 right-4 text-white text-4xl z-50"
            >
              &times;
            </button>
            <video
              src="https://res.cloudinary.com/dzngpgki4/video/upload/v1744223813/yfe3j4npfdq4krqly6cj.mp4 "
              controls
              autoPlay
              className="w-full h-full md:p-20  p-4 object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Solutions;
